import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const buttonVariants = cva(
  'tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-full tw-text-sm tw-font-semibold tw-tracking-wide tw-uppercase tw-transition-transform tw-duration-200 tw-ease-out tw-ring-offset-2 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-slate-900/10 focus-visible:tw-ring-offset-transparent disabled:tw-pointer-events-none disabled:tw-opacity-60 hover:tw-translate-y-[-1px] hover:tw-shadow-[0_0_18px_rgba(99,102,241,0.35)]',
  {
    variants: {
      variant: {
        default: 'tw-btn-base tw-bg-gradient-to-r tw-from-indigo-600 tw-via-indigo-500 tw-to-sky-500 tw-text-white hover:tw-shadow-lg hover:tw-shadow-indigo-400/40 active:tw-scale-[0.99]',
        secondary: 'tw-bg-slate-200 tw-text-slate-900 hover:tw-bg-slate-300 dark:tw-bg-slate-600 dark:hover:tw-bg-slate-500 dark:tw-text-white',
        outline: 'tw-outline-btn tw-bg-transparent tw-text-slate-700 hover:tw-bg-slate-100 dark:tw-bg-slate-600/60 dark:hover:tw-bg-slate-500/70',
        ghost: 'tw-text-slate-700 hover:tw-bg-slate-100 dark:tw-text-slate-100 dark:hover:tw-bg-slate-700',
      },
      size: {
        default: 'tw-h-10 tw-px-5',
        sm: 'tw-h-9 tw-px-4 tw-text-xs',
        lg: 'tw-h-11 tw-px-6 tw-text-base',
        icon: 'tw-h-10 tw-w-10',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : 'button';
  return (
    <Comp
      ref={ref}
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    />
  );
});

Button.displayName = 'Button';

export { Button, buttonVariants };
